import { isValueFalsey } from './valueCheck';
export const idBuilder = (prefix, id, sequence) => {
  let builtId = !isValueFalsey(id) ? `${prefix}-${id}` : prefix;
  builtId = typeof sequence === 'number' || !isValueFalsey(sequence) ? `${builtId}-${sequence}` : builtId;
  return builtId;
};